module.exports = __webpack_public_path__ + "static/media/confirm-list.eade44e0.svg";